// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"a9fc33da","312":"b2e4da07","632":"6b1613eb"}[chunkId] + ".css";
};